<template>
	<div>
		<ModalDetailWithdraw ref="ModalDetailWithdraw"></ModalDetailWithdraw>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Riwayat Pencairan Dana</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<!-- <v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn> -->
					<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent v-if="dropfilter" @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined >
			<v-data-table loading disable-pagination :headers="headers" :items="listEwallet" :search="search" hide-default-footer :options.sync="option" :server-items-length="paginationEwallet.total_data">
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="showDetail(item)" class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-text-box-search</v-icon>
							</v-btn>
						</template>
						<span>Detail</span>
					</v-tooltip>
				</template>
				<template v-slot:item.ewallet_withdrawal_log_datetime="{ item }">
					{{ item.ewallet_withdrawal_log_datetime | tanggalid }}
				</template>
				<template v-slot:item.ewallet_withdrawal_log_total_balance="{ item }">
					{{ item.ewallet_withdrawal_log_total_balance | toRupiah }}
				</template>
				<template v-slot:item.ewallet_withdrawal_log_total_admin="{ item }">
					{{ item.ewallet_withdrawal_log_total_admin | toRupiah }}
				</template>
				<template v-slot:item.ewallet_withdrawal_log_total_transfer="{ item }">
					{{ item.ewallet_withdrawal_log_total_transfer | toRupiah }}
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!paginationEwallet">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5" v-if="paginationEwallet">
			<v-row>
				<v-col cols="11" md="11" class="py-0 d-flex justify-space-between">
					<span>Total {{paginationEwallet.total_data | toNumber}} Data</span>
					<v-pagination v-model="page" :length="paginationEwallet.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="1" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import filterComponent from '@/components/Filter'
import ModalDetailWithdraw from './components/ModalDetailWithdraw'

export default {
	inject: ['theme'],
	components: {
		filterComponent, ModalDetailWithdraw
	},
	data() {
		return {
			sortBy: 'ewallet_balance',
			sortDir: 'DESC',
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Aksi', value: 'action'},
			{ text: 'Tanggal', align: 'start', value: 'ewallet_withdrawal_log_datetime'},
			{ text: 'Total Dana', align: 'start', value: 'ewallet_withdrawal_log_total_balance'},
			{ text: 'Biaya Admin', align: 'start', value: 'ewallet_withdrawal_log_total_admin'},
			{ text: 'Total Transfer', align: 'start', value: 'ewallet_withdrawal_log_total_transfer'},
			{ text: 'Keterangan', align: 'start', value: 'ewallet_withdrawal_log_note'},
			],
			params:[],
			isLoading: false,
			filterData: [{
				type: 'date',
				show: false,
				label: 'Tanggal',
				filter: {
					value: [],
					comparison: 'bet',
					type: 'date',
					field: 'ewallet_withdrawal_log_datetime'
				}
			},
			],
		}
	},
	computed: {
		...mapState(['filterParams']),
		...mapState('ecommerceEwallet', ['listEwallet', 'paginationEwallet']),
	},
	methods: {
		...mapActions('ecommerceEwallet', ['getEwalletWithdraw', 'exportEwalletWithdraw']),
		...mapMutations(['setFilter']),
		...mapMutations('ecommerceEwallet', ['clearDataEwallet']),

		getData() {
			this.getEwalletWithdraw(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		exportData() {
			this.exportEwalletWithdraw(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		async onResetFilter() {
			this.params = []
			this.getData()
		},
		showDetail(data) {
			this.$refs.ModalDetailWithdraw.showModal(data)
		}
	},
	beforeDestroy(){
		this.clearDataEwallet()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Ewallet Withdraw Ecommerce`)
		await this.getData()

		await this.setFilter(this.filterData)
	},
};
</script>

<style>
